<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      
    }
  },
  methods: {
      
  },
  
  watch: {
    /* $route(to, from,next)  {
      var that=this
      // 1. 判断是不是登录页面
      // 是登录页面
      if(to.path === '/login') {
        
      } else {
        // 不是登录页面
        // 2. 判断 是否登录过
        let token = localStorage.getItem('token')
        //后端请求判断token
        if(token=='123456'){

        }else{
          this.$alert('登录已超时', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              // that.$router.push('/login')
              next()
            }
          });
        }
      }
    } */
  },  
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
  }
  a{
    text-decoration: none;
  }
  li{
    list-style: none;
  }
  img{
    display: block;
  }
  /* html,body,#app{
    height: 100%;
  } */
  body{
    overflow-x: hidden;
  }
  /* #app{
    overflow: hidden;
  } */

  /* 公共 */
  #Zbcp .header .forms>.el-form-item{
      margin-right: 10px;
  }
  #Zbcp .content{
      min-height: 550px;
  }
  #Zbcp .content .btns:hover{
      cursor: pointer;
      text-decoration: underline;
  }
  /* 公共 */


  #Zbcp .header .el-form-item__label{
    color: #99a6bf ;
  }
  #Zbcp .header .el-form-item{
    margin-right: 0;
  }
  #Home tbody,#Home th,#Home td{
    border: none !important;
  }
  #Home tr:nth-of-type(2n+1){
    background: #2e384d;
  }
  #Home tr:nth-of-type(2n),#Home th{
    background: #262f40;
  }
  #Home .el-table::before{
    height: 0;
  }
  #Home tbody tr{
    color: #999;
    cursor: pointer;
  }
  #Home tbody tr:hover{
    color: rgb(28, 36, 51);
  }
  #Home .button{
    text-align: center;
    margin-top: 20px;
  }
  #Home .el-dialog__header{
    background: #eee;
    height: 24px;
  }
  #Home  .edit-form .ts>.el-form-item__content{
    margin-left:0 !important;
  }
  #Home .ts .el-form-item__content{
    display: flex;
  }
  #Home .ts .el-form-item__content label{
    width: 150px;
  }
  #Home .el-carousel__item{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #Home .el-dialog__wrapper{
    min-width: 1056px;
  }
  #Home .el-dialog__wrapper .el-dialog{
    max-width:700px;
  }


  .al .el-tabs__item{
        color: #99a6bf
    }
    .al .el-tabs__item.is-active{
      color: #fff;
    }
    .al .el-tabs__nav-wrap::after{
      background: none;
    }
    .hide .el-upload--picture-card{
      display: none;
    }
    .hide1 .el-upload--picture-card{
      display: none;
    }
    .hide2 .el-upload--picture-card{
      display: none;
    }
    .el-tabs__item{
        color:#fff !important;
        padding: 0 40px !important;
    }
    .el-tabs__item:hover {
        color: #409eff !important;
    }
    .el-tabs__item.is-active {
      color: #409eff !important;
    }
   /*  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    } */


    /* 预览图片 */
    .el-carousel__item img{
      width: 100%;
    }
    .pswp{
      z-index: 9999 !important;
    }



    .el-upload-list__item:before{
      display: inline-block;
                vertical-align: middle;
                content: '';
                height: 100%;
    }
    .el-upload-list__item img{
      display: inline-block;
      height: auto !important; 
                vertical-align: middle;
    }



    /* .sortable-ghost{
        background: yellow !important;
    } */
    /* .sortable-drag{
        background: red !important;
    } */
    /* .sortable-chosen{
        background: orange !important;
    } */

    #table .sortable-ghost{
        background: #fff !important;
        color: #000 !important;
    }
    #table  tr:hover{
        color: #999 !important;
    }
    #table  tr:hover>td{
        background: none !important;
    }
    .muban{
  width: 70px;
  height: 20px;
  border-bottom: 1px solid #fff;
  margin-left: 30rpx;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue